import React, { useEffect, useState } from 'react';
import { NavLink, Link, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import { Form } from 'react-bootstrap';
import Select from 'react-select';
import i18next from 'i18next';
import { login, resetPassword, registerWorkerResetState } from '../../../actions';
import { validateEmptyString, validateEmail, getLanguages, getRedirectUrl } from '../../../helpers';
import { getItem, setItem } from '../../../helpers/storage';
import { sendError } from '../../../services/errorService';
import { globalConstants, sideBarConstants } from '../../../constants';
import bookAllRegisterPhoto from '../../../assets/images/register.png';
import mobilePhoto from '../../../assets/images/mobile.png';
import { GoogleLoginComponent, AppleLoginComponent } from '../../components';
import mainLogo from '../../../assets/images/main logo.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faUser } from '@fortawesome/free-solid-svg-icons';
import { GoogleOAuthProvider } from '@react-oauth/google';

const Login = ({ t }) => {
	const dispatch = useDispatch();
	const [inputs, setInputs] = useState({
		email: '',
		password: ''
	});
	const [showForgetPasswordForm, setShowForgetPasswordForm] = useState(false);
	const [emailWrongFormat, setEmailWrongFormat] = useState(false);
	const [emailEmpty, setEmailEmpty] = useState(false);
	const [resetEmailWrongFormat, setResetEmailWrongFormat] = useState(false);
	const [resetEmailEmpty, setResetEmailEmpty] = useState(false);
	const [passwordError, setPasswordError] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const { email, resetEmail, password } = inputs;
	const { loggedIn, userAttributes, resetingPasswordLoading, passwordReset } = useSelector((state) => state.authentication);
	const { workerRegister } = useSelector((state) => state.workerReducer);
	const languages = getLanguages();
	const language = getItem('lng');
	const [selectedLanguage, setSelectedLanguage] = useState(language ? languages.find((l) => l.value === language) : languages[0]);

	useEffect(() => {
		dispatch({ type: sideBarConstants.INFO_BOX_HIDDEN, hidden: true });
		dispatch({ type: sideBarConstants.INFO_BOX_OPEN, open: false });
	}, [dispatch]);

	useEffect(() => {
		try {
			const timer = setTimeout(() => {
				dispatch(registerWorkerResetState());
			}, 4000);
			return () => clearTimeout(timer);
		} catch (error) {
			sendError('Login - useEffect - dispatch, workerRegister', error.message);
		}
	}, [dispatch, workerRegister]);

	const handleOnChange = (e) => {
		const { name, value } = e.target;
		if (name === 'password') {
			setPasswordError(!validateEmptyString(value));
		} else {
			if (name === 'email') {
				if (value === '') {
					setEmailEmpty(true);
					setEmailWrongFormat(false);
				} else {
					setEmailEmpty(false);
					if (validateEmail(value)) {
						setEmailWrongFormat(false);
					}
				}
			}

			if (name === 'resetEmail') {
				if (value === '') {
					setResetEmailEmpty(true);
					setResetEmailWrongFormat(false);
				} else {
					setResetEmailEmpty(false);
					if (validateEmail(value)) {
						setResetEmailWrongFormat(false);
					}
				}
			}
		}
		setInputs((inputs) => ({ ...inputs, [name]: value }));
	};

	const emailValidation = () => {
		if (email === '') {
			setEmailEmpty(true);
			setEmailWrongFormat(false);
			return false;
		} else {
			setEmailEmpty(false);
			if (validateEmail(email)) {
				setEmailWrongFormat(false);
				return true;
			} else {
				setEmailWrongFormat(true);
				return false;
			}
		}
	};

	const resetEmailValidation = () => {
		if (resetEmail === '') {
			setResetEmailEmpty(true);
			setResetEmailWrongFormat(false);
			return false;
		} else {
			setResetEmailEmpty(false);
			if (validateEmail(resetEmail)) {
				setResetEmailWrongFormat(false);
				return true;
			} else {
				setResetEmailWrongFormat(true);
				return false;
			}
		}
	};

	const getEmailErrorMessage = () => {
		if (emailEmpty) {
			return t('error.required');
		} else if (emailWrongFormat) {
			return t('error.email_wrong_format');
		} else return '';
	};

	const getResetEmailErrorMessage = () => {
		if (resetEmailEmpty) {
			return t('error.required');
		} else if (resetEmailWrongFormat) {
			return t('error.email_wrong_format');
		} else return '';
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (!emailEmpty && !emailWrongFormat && !passwordError) {
			dispatch(login(email, password, selectedLanguage.value));
		}
	};

	const handleSubmitResetPassword = (e) => {
		e.preventDefault();
		if (!resetEmailEmpty && !resetEmailWrongFormat) {
			dispatch(resetPassword(resetEmail));
		}
	};

	const handleOnChangeLanguage = (option) => {
		const lngValue = option.value;
		i18next.changeLanguage(lngValue);
		setSelectedLanguage(option);
		setItem('lng', lngValue);
	};

	if (!loggedIn) {
		return (
			<div className="c-app c-default-layout flex-row align-items-center bookall-page-wrapper">
				<img className="bookall-page__register-img" src={bookAllRegisterPhoto} alt="bookall register" />
				<div className="login-form container">
					{(passwordReset || workerRegister) && (
						<div className="justify-content-center row">
							<div className="col-12 col-md-8 col-lg-8 col-xl-6 col-xxl-5">
								<div className="mx-8 card-shadow card">
									{passwordReset && <div className="card-body p-4 register-form__add-user">{t('label.email_reset_password')}</div>}
									{workerRegister && (
										<div className="card-body p-4 register-form__add-user">{t('success.password_successfully_changed')}</div>
									)}
								</div>
							</div>
						</div>
					)}
					<div className="justify-content-center row">
						<div className="col-12 col-md-8 col-lg-8 col-xl-6 col-xxl-5">
							<div className="mx-8 card-shadow card">
								<div className="card-body p-4 login-form__welcome-wrapper">
									<img className="main-logo" src={mainLogo} alt="logo" />
									<label>
										{t('label.bookall_welcome')}
										<Link
											to="#"
											target="_blank"
											onClick={(e) => {
												e.preventDefault();
												window.location = `mailto:${globalConstants.BOOKALL_MAIL}`;
											}}>
											{globalConstants.BOOKALL_MAIL}.
										</Link>
									</label>
								</div>
							</div>
						</div>
					</div>
					<div className="justify-content-center row">
						<div className="col-12 col-md-8 col-lg-8 col-xl-6 col-xxl-5">
							<div className="mx-8 card-shadow card login-form__outer-wrapper">
								<>
									<div className="card-header flex-row-center">
										<span className="login-form__login">
											{!showForgetPasswordForm ? t('label.login') : t('label.reset_password')}
										</span>
										<Select
											className="register-form__lng-select login-form__language-select"
											placeholder={t('label.select...')}
											options={languages}
											onChange={handleOnChangeLanguage}
											value={selectedLanguage}
										/>
									</div>
									{!showForgetPasswordForm ? (
										<div className="card-body p-4 login-form__inner-wrapper">
											<Form>
												<p className="text-muted">{t('label.sign_in_to_your_account')}</p>
												<div className="input-group mb-3">
													<div className="input-group-prepend">
														<div className="input-group-text">
															<FontAwesomeIcon icon={faUser} />
														</div>
													</div>
													<Form.Control
														type="email"
														name="email"
														placeholder={t('label.email_address')}
														onChange={handleOnChange}
														onBlur={emailValidation}
														isInvalid={emailEmpty || emailWrongFormat}
														maxLength={150}
													/>
													<Form.Control.Feedback type="invalid" name="emailInvalid">
														{getEmailErrorMessage()}
													</Form.Control.Feedback>
												</div>
												<div className="input-group mb-4 login-page__password-wrapper">
													<div className="input-group-prepend">
														<div className="input-group-text">
															<FontAwesomeIcon icon={faLock} />
														</div>
													</div>
													<input
														className="form-control"
														name="password"
														type={showPassword ? 'text' : 'password'}
														placeholder={t('label.password')}
														autoComplete="current-password"
														onChange={handleOnChange}
													/>
													<span className="login-page__show-password" onClick={() => setShowPassword(!showPassword)}>
														{showPassword ? t('label.hide').toLowerCase() : t('label.show').toLowerCase()}
													</span>
												</div>
												<button
													className="login-form__login-button btn btn-primary"
													type="submit"
													disabled={
														emailEmpty ||
														emailWrongFormat ||
														!validateEmail(email) ||
														passwordError ||
														!validateEmptyString(email) ||
														!validateEmptyString(password)
													}
													onClick={handleSubmit}>
													{t('label.login')}
												</button>
												<GoogleOAuthProvider clientId={globalConstants.GOOGLE_CLIENT_ID}>
													<GoogleLoginComponent label="label.login_with_gmail" type={globalConstants.LOGIN} />
												</GoogleOAuthProvider>
												<AppleLoginComponent label={t('label.login_with_apple')} type={globalConstants.LOGIN} />
												<div md="12" className="login-form__forgot-password">
													<button className="px-0 btn btn-link" onClick={() => setShowForgetPasswordForm(true)}>
														{t('label.forgot_password')}
													</button>
												</div>
											</Form>
										</div>
									) : (
										<div className="card-body p-4 login-form__inner-wrapper">
											<Form>
												<div className="input-group mb-3">
													<div className="input-group-prepend">
														<div className="input-group-text">
															<FontAwesomeIcon icon={faUser} />
														</div>
													</div>
													<Form.Control
														type="email"
														name="resetEmail"
														autoComplete="resetEmail"
														placeholder={t('label.email_address')}
														onChange={handleOnChange}
														onBlur={resetEmailValidation}
														isInvalid={resetEmailEmpty || resetEmailWrongFormat}
														maxLength={150}
													/>
													<Form.Control.Feedback type="invalid" name="resetEmailInvalid">
														{getResetEmailErrorMessage()}
													</Form.Control.Feedback>
												</div>
												<div className="row">
													<div xs="12">
														<button
															type="submit"
															className="px-4 login-form__login-button btn btn-primary"
															disabled={
																resetEmailEmpty ||
																resetEmailWrongFormat ||
																!validateEmail(resetEmail) ||
																!validateEmptyString(resetEmail) ||
																resetingPasswordLoading
															}
															onClick={handleSubmitResetPassword}>
															{t('label.reset_password')}
														</button>
													</div>
													<div md="12" className="login-form__forgot-password">
														<button className="px-0 btn btn-link" onClick={() => setShowForgetPasswordForm(false)}>
															{t('label.have_account_login')}
														</button>
													</div>
												</div>
											</Form>
										</div>
									)}
									<div className="card-footer">
										<div className="login-form__open-an-account">
											<NavLink to="/register" color="link">
												{t('label.do_not_have_an_account')}
											</NavLink>
										</div>
									</div>
								</>
							</div>
						</div>
					</div>
				</div>
				<img className="bookall-page__mobile-img" src={mobilePhoto} alt="bookall application" />
			</div>
		);
	}
	return <Redirect to={getRedirectUrl(userAttributes)} />;
};

export default withNamespaces()(Login);
